import {MipElement, MIP_ELEMENTS} from '@domain/pom'
import {ControlledSelect} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ValidationResult} from '../../common/validator/validator.types'
import {FEATURE_NAMESPACE} from '../../consts'

// the element is optional, so the list carries a blank entry to unset it again
const EMPTY_VALUE = ''

type Props = {
  value?: MipElement
  onChange?: (value?: MipElement) => void
  error?: ValidationResult
  disabled?: boolean
}

export const MipElementField: React.FC<Props> = ({value, onChange, error, disabled}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const options = [
    {value: EMPTY_VALUE, label: '-'},
    ...MIP_ELEMENTS.map((element) => ({
      value: element,
      label: t(`mipElement.${element}`)
    }))
  ]

  return (
    <ControlledSelect
      name="action-mip-element"
      label={t('actionDialog.mipElement')}
      value={value ?? EMPTY_VALUE}
      values={options}
      isDisabled={disabled}
      state={error ? 'error' : undefined}
      error={error ? t(error) : undefined}
      isTouched={Boolean(error)}
      scrollable
      className="w-full"
      // the blank entry reports a falsy value, which clears the field
      onChange={(next) => onChange?.(next ? (next as MipElement) : undefined)}
      data-cy="action-mip-element"
      data-test-id="action-mip-element"
    />
  )
}
